import { createCountriesQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useCountriesQuery = createCountriesQuery(HTTP_CONFIG.API.Consumer.url)
